import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { MessageIsoButton } from "./MessageIsoButton";

export const lookingText = (n, fr) => (fr
  ? `Quelqu'un cherche ceci! · ${n} ${n === 1 ? "acheteur" : "acheteurs"}`
  : `Someone's looking for this! · ${n} ${n === 1 ? "shopper" : "shoppers"}`);

// Owner-only: shows ISO shoppers whose search matches this ad
export const IsoDemandTag = ({ listing, fr }) => {
  const listingId = listing.id;
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/my/listings/${listingId}/iso-demand`).then((r) => setD(r.data)).catch(() => {}), [listingId]);
  useEffect(() => { load(); }, [load]);
  if (!d?.count) return null;
  return (
    <div className="mt-4 rounded-xl border border-[#FFC233] bg-[#FFF9E8] px-4 py-3" data-testid="iso-demand-tag">
      <p className="font-display font-bold text-[#12234A] flex items-center gap-2" data-testid="iso-demand-count">
        <span className="h-7 w-7 rounded-full bg-[#FFC233] flex items-center justify-center shrink-0"><Search size={14} strokeWidth={3} /></span>
        {lookingText(d.count, fr)}
      </p>
      <p className="text-xs text-slate-500 mt-1">{fr ? "Ces annonces Recherché correspondent à votre annonce. Seul vous voyez ceci." : "These ISO ads match your ad. Only you can see this."}</p>
      <ul className="mt-2 space-y-1">
        {d.items.map((i) => (
          <li key={i.id}><Link to={`/listing/${i.id}`} data-testid={`iso-demand-item-${i.id}`} className="flex items-center gap-2 text-sm text-[#12234A] hover:text-[#F5551E] transition-colors">
            <span className="text-[10px] font-black tracking-widest bg-[#FFC233] px-1.5 py-0.5 rounded">ISO</span>
            <span className="truncate flex-1">{i.title}</span>
            {i.messaged && <span className="text-[10px] font-semibold text-emerald-700 shrink-0" data-testid={`iso-demand-messaged-${i.id}`}>{fr ? "Contacté" : "Messaged"}</span>}
            <span className="text-xs text-slate-400 flex items-center gap-1 shrink-0"><MapPin size={11} /> {i.city}, {i.province}</span>
          </Link></li>
        ))}
      </ul>
      <MessageIsoButton listing={listing} left={d.count - (d.messaged || 0)} fr={fr} onSent={load} />
    </div>
  );
};
